/* eslint-disable */

type TInter = string | number;
export default {
  admin: {
    events: {
      liveProducer: {
        /**
         * @DE Beantwortet
         * @EN Answered
         */
        answered: "admin.events.liveProducer.answered",
        /**
         * @DE Einklappen
         * @EN Collapse
         */
        collapse: "admin.events.liveProducer.collapse",
        /**
         * @DE Ausklappen
         * @EN Expand
         */
        expand: "admin.events.liveProducer.expand",
        /**
         * @DE Live
         * @EN Live
         */
        live: "admin.events.liveProducer.live",
        /**
         * @DE Fragen werden geladen...
         * @EN Loading questions...
         */
        loadingQuestions: "admin.events.liveProducer.loadingQuestions",
        /**
         * @DE Neu
         * @EN New
         */
        new: "admin.events.liveProducer.new",
        /**
         * @DE Es gibt keine Fragen die diesen Status haben
         * @EN There are no questions with this status
         */
        noQuestions: "admin.events.liveProducer.noQuestions",
        /**
         * @DE Es gab einen Fehler beim Laden der Fragen
         * @EN There was an error loading the questions
         */
        hasError: "admin.events.liveProducer.hasError",
        /**
         * @DE Fragen
         * @EN Questions
         */
        questions: "admin.events.liveProducer.questions",
      },
      qa: {
        /**
         * @DE Bearbeitung dieser Frage abbrechen
         * @EN Abort editing this question
         */
        abortCurrentEdit: "admin.events.qa.abortCurrentEdit",
        /**
         * @DE Freigabe der aktuellen Bearbeitung abbrechen
         * @EN Abort the override of current edit
         */
        abortOverrideCurrentEdit: "admin.events.qa.abortOverrideCurrentEdit",
        /**
         * @DE Aktionsmenü
         * @EN Action menu
         */
        actionMenu: "admin.events.qa.actionMenu",
        /**
         * @DE Beantwortet
         * @EN Answered
         */
        answered: "admin.events.qa.answered",
        /**
         * @DE Als anonymer Benutzer
         * @EN As anonymous user
         */
        asAnonymous: "admin.events.qa.asAnonymous",
        /**
         * @DE Als Back-Office Benutzer
         * @EN As back office user
         */
        asBackOffice: "admin.events.qa.asBackOffice",
        /**
         * @DE Teilnehmer
         * @EN Attendees
         */
        attendees: "admin.events.qa.attendees",
        /**
         * @DE Zur originalen Ansicht zurückkehren
         * @EN Go back to the original view
         */
        backToOriginalView: "admin.events.qa.backToOriginalView",
        /**
         * @DE Abbrechen
         * @EN Cancel
         */
        cancel: "admin.events.qa.cancel",
        /**
         * @DE Frage löschen
         * @EN Delete question
         */
        deleteQuestion: "admin.events.qa.deleteQuestion",
        /**
         * @DE Gelöscht
         * @EN Deleted
         */
        deleted: "admin.events.qa.deleted",
        /**
         * @DE Frage bearbeiten
         * @EN Edit question
         */
        editQuestion: "admin.events.qa.editQuestion",
        /**
         * @DE Diese Frage wird gerade von %{editor} bearbeitet. Durch das fortfahren können Sie die Bearbeitung übernehmen. Bitte beachten sie, dass dies %{editor} aus dem Bearbeitungsmodus entfernt.
         * @EN This question is currently being edited by %{editor}. By proceeding you will take over the edit. Please note that this will remove %{editor} from the edit mode.
         */
        editedByWarningMessage: ({
          editor,
        }: {
          editor: TInter;
        }): [
          string,
          {
            editor: TInter;
          },
        ] => [
          "admin.events.qa.editedByWarningMessage",
          {
            editor,
          },
        ],
        /**
         * @DE Frage ist leer
         * @EN Question is empty
         */
        emptyQuestion: "admin.events.qa.emptyQuestion",
        /**
         * @DE Vollbildmodus mit Browser betreten
         * @EN Enter fullscreen mode with your browser
         */
        enterFullscreen: "admin.events.qa.enterFullscreen",
        /**
         * @DE Bitte geben Sie eine Frage ein
         * @EN Please enter a question
         */
        enterQuestion: "admin.events.qa.enterQuestion",
        /**
         * @DE Fragen exportieren
         * @EN Export questions
         */
        exportQuestions: "admin.events.qa.exportQuestions",
        /**
         * @DE Browser Fenster mit dem Q&A-Tool füllen
         * @EN Fill the entire browser window with the Q&A Tool
         */
        fillWindowWithTool: "admin.events.qa.fillWindowWithTool",
        /**
         * @DE Vollbildmodus verlassen
         * @EN Leave fullscreen mode
         */
        leaveFullscreen: "admin.events.qa.leaveFullscreen",
        /**
         * @DE Live
         * @EN Live
         */
        live: "admin.events.qa.live",
        /**
         * @DE Neu
         * @EN New
         */
        new: "admin.events.qa.new",
        /**
         * @DE Keine Teilnehmer
         * @EN No attendees
         */
        noAttendees: "admin.events.qa.noAttendees",
        /**
         * @DE Keine Änderungen zum speichern
         * @EN No changes to save
         */
        noChanges: "admin.events.qa.noChanges",
        /**
         * @DE Notizen
         * @EN Notes
         */
        notes: "admin.events.qa.notes",
        /**
         * @DE Freigabe der aktuellen Bearbeitung anfordern
         * @EN Request unlocking of current edit
         */
        overrideCurrentEdit: "admin.events.qa.overrideCurrentEdit",
        pendingRequestQuestion: {
          /**
           * @DE Verlassen des Bearbeitungsmodus und Abbrechen der Änderungen...
           * @EN Leaving edit mode and canceling changes...
           */
          cancelEdit: "admin.events.qa.pendingRequestQuestion.cancelEdit",
          /**
           * @DE Frage wird gelöscht...
           * @EN Deleting the question...
           */
          delete: "admin.events.qa.pendingRequestQuestion.delete",
          /**
           * @DE Bearbeitungsmodus wird aktiviert...
           * @EN Entering edit mode...
           */
          edit: "admin.events.qa.pendingRequestQuestion.edit",
          /**
           * @DE Frage wird veröffentlicht...
           * @EN Publishing the question...
           */
          publish: "admin.events.qa.pendingRequestQuestion.publish",
          /**
           * @DE Zurücksetzen der Änderung an der Fragenachricht...
           * @EN Reverting the changes for the question message...
           */
          revert: "admin.events.qa.pendingRequestQuestion.revert",
          /**
           * @DE Änderungen werden gespeichert...
           * @EN Saving changes...
           */
          savingChanges: "admin.events.qa.pendingRequestQuestion.savingChanges",
          /**
           * @DE Frage wird unveröffentlicht...
           * @EN Unpublishing the question...
           */
          unpublish: "admin.events.qa.pendingRequestQuestion.unpublish",
        },
        placeholder: {
          /**
           * @DE Geben Sie hier Ihre Notizen ein...
           * @EN Enter your notes here...
           */
          notes: "admin.events.qa.placeholder.notes",
          /**
           * @DE Geben Sie hier Ihre Frage ein...
           * @EN Enter your question here...
           */
          question: "admin.events.qa.placeholder.question",
        },
        /**
         * @DE Beendet
         * @EN Post
         */
        post: "admin.events.qa.post",
        /**
         * @DE Geplant
         * @EN Pre
         */
        pre: "admin.events.qa.pre",
        /**
         * @DE Diese Frage veröffentlichen
         * @EN Publish this question
         */
        publishQuestion: "admin.events.qa.publishQuestion",
        /**
         * @DE Frage
         * @EN Question
         */
        question: "admin.events.qa.question",
        /**
         * @DE Frage wird bearbeitet von %{editor}
         * @EN Question is edited by %{editor}
         */
        questionEditedBy: ({
          editor,
        }: {
          editor: TInter;
        }): [
          string,
          {
            editor: TInter;
          },
        ] => [
          "admin.events.qa.questionEditedBy",
          {
            editor,
          },
        ],
        /**
         * @DE Änderung der Fragenachricht zurücksetzen
         * @EN Instantly revert edit of the question message
         */
        revertQuestionEdit: "admin.events.qa.revertQuestionEdit",
        /**
         * @DE Speichern
         * @EN Save
         */
        save: "admin.events.qa.save",
        /**
         * @DE Änderungen speichern
         * @EN Save changes
         */
        saveChanges: "admin.events.qa.saveChanges",
        /**
         * @DE Frage senden
         * @EN Submit the question
         */
        submitQuestion: "admin.events.qa.submitQuestion",
        /**
         * @DE Übernehmen
         * @EN Take over
         */
        takeOver: "admin.events.qa.takeOver",
        /**
         * @DE Spalte für gelöschte Fragen ein-/ausblenden
         * @EN Toggle column for deleted questions
         */
        toggleDeletedQuestions: "admin.events.qa.toggleDeletedQuestions",
        /**
         * @DE Inputfeld für neue Frage ein-/ausblenden
         * @EN Toggle input field for new question
         */
        toggleNewQuestionInput: "admin.events.qa.toggleNewQuestionInput",
        /**
         * @DE Unbekannter Bearbeiter
         * @EN Unknown editor
         */
        unknownEditor: "admin.events.qa.unknownEditor",
        /**
         * @DE Diese Frage unveröffentlichen
         * @EN Unpublish this question
         */
        unpublishQuestion: "admin.events.qa.unpublishQuestion",
        validation: {
          /**
           * @DE Hinweis: Eine leere Notiz entspricht dem Entfernen aus der Frage.
           * @EN Remark: An empty note equates to removing it from the question.
           */
          notesEmpty: "admin.events.qa.validation.notesEmpty",
          /**
           * @DE Eine Frage darf nicht leer sein!
           * @EN A Question must not be empty!
           */
          questionEmpty: "admin.events.qa.validation.questionEmpty",
          /**
           * @DE Es gibt ungespeicherte Änderungen!
           * @EN There are unsaved changes!
           */
          unsavedChanges: "admin.events.qa.validation.unsavedChanges",
        },
        /**
         * @DE Warnung
         * @EN Warning
         */
        warning: "admin.events.qa.warning",
      },
    },
  },
};
